'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _reactRedux = require('react-redux');

var _reactRouterDom = require('react-router-dom');

var _effects = require('redux-saga/effects');

var _NavigationService = require('../../services/NavigationService');

var _Store = require('../../services/Store');

var _NavigationApp = require('./NavigationApp');

var _NavigationApp2 = _interopRequireDefault(_NavigationApp);

var _SetScreenIdAction = require('../../components/screen/actions/SetScreenIdAction');

var _SetScreenIdAction2 = _interopRequireDefault(_SetScreenIdAction);

var _ClickTracker = require('../../services/ClickTracker');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [onNavigation].map(_regenerator2.default.mark);

function onNavigation(location, props) {
  return _regenerator2.default.wrap(function onNavigation$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.call)(_NavigationService.onRouteNavigation, props.routes, location.pathname, location.state);

        case 2:

          if (props.onNavigation) {
            props.onNavigation(location);
          }

        case 3:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    onWillMount: function onWillMount() {
      // initialize screenId on store and log first navigation
      var route = (0, _NavigationService.getRoute)(ownProps.routes, ownProps.hashRouter ? window.location.hash.replace('#', '') : window.location.pathname);

      if (route) {
        (0, _ClickTracker.addNavigationTrack)(route.id, window.location.href);
        dispatch((0, _SetScreenIdAction2.default)(route.id));
      }

      if (ownProps.onFirstNavigation) {
        ownProps.onFirstNavigation();
      }
    },
    onNavigationChange: function onNavigationChange(location) {
      (0, _Store.runSaga)(onNavigation, location, ownProps);
    }
  };
};

exports.default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(undefined, mapDispatchToProps)(_NavigationApp2.default));


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/navigation/NavigationAppContainer.js
// module id = 748
// module chunks = 10